import React from "react";
import { Link } from "react-router-dom";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)" }} data-testid="refund-policy-page">
      {/* Header */}
      <header className="max-w-4xl mx-auto px-6 sm:px-10 pt-8 pb-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <div className="w-9 h-9 rounded-xl bg-sage-soft flex items-center justify-center">
            <span className="text-sage font-semibold">🌿</span>
          </div>
          <span className="font-semibold text-sage">Mon Cabinet Bien-être</span>
        </Link>
        <Link to="/" className="btn-ghost text-sm" data-testid="nav-home">
          ← Retour
        </Link>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 sm:px-10 pb-16">
        <h1 className="text-3xl sm:text-4xl font-semibold text-sage mb-2" data-testid="refund-title">
          Politique de remboursement
        </h1>
        <p className="text-sm text-muted-soft mb-8">
          Dernière mise à jour&nbsp;: {new Date().toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
        </p>

        <section className="space-y-6 text-sm leading-relaxed" style={{ color: "var(--fg)" }}>
          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">1. Garantie satisfait ou remboursé — 14 jours</h2>
            <p>
              L'abonnement <strong>Mon Cabinet Bien-être</strong> (19,99&nbsp;€ TTC / mois) est proposé avec une
              <strong> garantie satisfait ou remboursé de 14 jours calendaires</strong> à compter de la date du premier paiement.
            </p>
            <p className="mt-2">
              Si, pendant cette période, vous n'êtes pas satisfait·e du service, vous pouvez demander le remboursement
              intégral de votre premier prélèvement, sans avoir à vous justifier.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">2. Comment demander un remboursement ?</h2>
            <p>Il vous suffit d'envoyer un e-mail à&nbsp;:</p>
            <p className="mt-2">
              📧 <a href="mailto:contact@capsulepatrimoine.com" className="text-sage hover:underline">contact@capsulepatrimoine.com</a>
            </p>
            <p className="mt-2">
              en précisant&nbsp;:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>l'adresse e-mail utilisée pour votre inscription&nbsp;;</li>
              <li>la date approximative de votre premier paiement&nbsp;;</li>
              <li>(facultatif) la raison qui vous pousse à demander un remboursement — cela nous aide à améliorer le service.</li>
            </ul>
            <p className="mt-2">
              Aucune justification n'est exigée pendant la période de 14 jours. Le remboursement est de droit.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">3. Délai de traitement</h2>
            <p>
              Le remboursement est initié <strong>sous 5 jours ouvrés</strong> après réception de votre demande.
              Il est effectué sur la carte bancaire ayant servi au paiement, via notre prestataire Stripe.
            </p>
            <p className="mt-2">
              Le crédit apparaît sur votre relevé bancaire sous <strong>5 à 10 jours ouvrés</strong> supplémentaires,
              selon les délais de votre banque.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">4. Après 14 jours — résiliation sans engagement</h2>
            <p>
              Passé le délai de 14 jours, l'abonnement n'est plus remboursable, mais reste
              <strong> sans aucun engagement de durée</strong>. Vous pouvez le résilier à tout moment depuis&nbsp;:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>votre espace <strong>Réglages → Abonnement</strong>&nbsp;;</li>
              <li>ou en écrivant à <a href="mailto:contact@capsulepatrimoine.com" className="text-sage hover:underline">contact@capsulepatrimoine.com</a>.</li>
            </ul>
            <p className="mt-2">
              La résiliation prend effet à la fin de la période mensuelle en cours&nbsp;: vous conservez l'accès
              au service jusqu'à cette date, aucun nouveau prélèvement n'est effectué.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">5. Cas particuliers</h2>
            <p>Sont exclus du droit au remboursement&nbsp;:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>les prélèvements mensuels postérieurs à la période initiale de 14 jours (résiliation possible mais pas de remboursement rétroactif)&nbsp;;</li>
              <li>les comptes suspendus ou clôturés pour non-respect des conditions d'utilisation (fraude, usurpation d'identité, revente non autorisée).</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">6. Droit de rétractation légal</h2>
            <p>
              Conformément à l'<strong>article L221-28 du Code de la consommation</strong>, en tant que service numérique
              fourni sans support matériel, l'exécution du contrat commence dès le premier paiement avec votre accord exprès,
              ce qui peut faire perdre le droit de rétractation légal.
            </p>
            <p className="mt-2">
              Toutefois, la <strong>garantie commerciale de 14 jours</strong> décrite ci-dessus vous est offerte
              indépendamment de ce droit légal, et vous permet dans les faits d'obtenir un remboursement intégral
              sur la période concernée.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-sage mb-2">7. Contact</h2>
            <p>
              Pour toute question relative à cette politique&nbsp;:
            </p>
            <p className="mt-2">
              <strong>Capsule Patrimoine</strong><br />
              SIRET 484 280 771 00060<br />
              📧 <a href="mailto:contact@capsulepatrimoine.com" className="text-sage hover:underline">contact@capsulepatrimoine.com</a>
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="px-6 sm:px-10 py-10 text-center text-xs text-muted-soft border-t" style={{ borderColor: "var(--border)" }}>
        Mon Cabinet Bien-être — édité par Capsule Patrimoine · SIRET 484 280 771 00060 · Contact&nbsp;:{" "}
        <a href="mailto:contact@capsulepatrimoine.com" className="text-sage hover:underline">contact@capsulepatrimoine.com</a>
      </footer>
    </div>
  );
}
